<template>
  <v-dialog
    v-model="show"
    scrollable
    @click:outside="closeDialog"
    @keydown.esc="closeDialog"
  >
    <v-card>
       <span>
        <v-btn
          icon
          @click="closeDialog"
          style="position: absolute; right:0;"
        >
          <v-icon color="primary">mdi-close</v-icon>
        </v-btn>
      </span>
      <v-card-title>
        <slot name="title">
          <h2 class="section-header__title">Предложение по установлению КЦП</h2>
        </slot>
      </v-card-title>
      <v-card-text>
        <v-form
          class="data-card__input"
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-row class="info-card" dense no-gutters>
            <template v-for="(row, i) in configWorked">
              <v-col
                class="info-card__additional-header"
                :key="row.dataField+'AdditionalHeader'"
                v-if="row.additionalText"
                cols="12">
                {{ row.additionalText }}
              </v-col>
              <v-col
                :cols="row.cols ? row.cols : 12"
                class="info-card__field"
                :class="{'pr-3': calcPadding(i)}"
                :key="row.dataField"
              >
                <div v-if="row.text" class="info-card__name">
                  {{ row.text }}
                </div>
                <v-text-field
                  v-if="row.typeVar === 'input' || row.typeVar === 'integer'"
                  v-model="editableData[row.dataField]"
                  :disabled="row.disabled || disabled"
                  :rules="calcRules(row)"
                  :type="row.type ? row.type : 'text'"
                  color="#00599B"
                  outlined
                  background-color="#E3EFFA"
                  class="info-card__cell"
                  dense
                />
                <v-autocomplete
                  v-else-if="row.typeVar === 'selector'"
                  v-model="editableData[row.dataField]"
                  :items="spr[row.sprDataName]"
                  background-color="#E3EFFA"
                  :loading="loadingMinMaxValues"
                  :rules="calcRules(row)"
                  label="Выберите..."
                  no-data-text="По вашему запросу ничего нет"
                  :disabled="row.disabled || disabled"
                  dense
                  class="info-card__cell mt-2"
                  clearable
                  outlined
                  @change="loadNewMaxMinValues($event)"
                />
              </v-col>
            </template>
          
          </v-row>
        </v-form>
      </v-card-text>
      <div v-if="error" class="pl-4 error--text">
        {{ error }}
      </div>
      <v-card-actions class="d-flex flex-row align-center justify-start">
        
        <slot name="actions" :close="closeDialog" :valid="valid" :send-data="saveData">
          <v-btn
            class='blue__v-btn'
            @click="saveData"
            :loading="saving"
            :disabled="!valid || disabled"
          >
            Сохранить
          </v-btn>
          <v-btn
            class='white__v-btn ml-2'
            @click="closeDialog"
          >
            Отменить
          </v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapSpr} from "@/components/Dialogs/helpers";
import rules from "@/utils/rules";
import {mapActions, mapGetters} from "vuex";
import Form2OffersController from "@/controllers/Organizations/Forms(2-4)/Form2OffersController";

export default {
  name: "dialogForm2",
  props: {
    additionalData: {
      type: Object,
      default: () => ({})
    },
    dataForDialog: {
      type: Object,
      default: () => ({})
    },
    saving: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    config: {
      type: Array,
      default: () => ([])
    },
    orgID: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      show: false,
      valid: true,
      loadingMinMaxValues: false,
      minMaxValues: {},
      editableData: {},
      configWorked: [...this.config],
      rules: rules
    }
  },
  computed: {
    ...mapGetters('spr', {getKcpGroupsOrg: 'getKcpGroupsOrg'}),
    spr() {
      return {
        kcpGroup: mapSpr(this.getKcpGroupsOrg, 'id', (el) => `${el.code} ${el.name}`),
        
      }
    }
  },
  watch: {
    show() {
      this.initData()
      this.initConfig()
      if (this.editableData.kcpGroupId) {
        setTimeout(() => {
          this.valid = this.$refs?.form?.validate()
        }, 200)
      }
    },
    
  },
  dialogController: null,
  created() {
    this.initData();
    this.initConfig();
  },
  methods: {
    ...mapActions('notifications', {addNotification: 'addNotification'}),
    initConfig() {
      this.configWorked = this.configWorked.map(el => {
          return {
            ...el,
            [el.dataField]: this.editableData[el.dataField],
            disabled: this.disabled || el.disabled
          }
        }
      )
    },
    initData() {
      if (!this.dataForDialog) {
        this.configWorked.forEach(el => {
          this.editableData[el.dataField] = null
        });
        return
      }
      this.configWorked.forEach(el => {
        if (el.initUpdate)
          this.loadNewMaxMinValues(this.dataForDialog[el.dataField])
        this.editableData[el.dataField] = this.dataForDialog[el.dataField] ?? null
      })
    },
    calcRules(row) {
      return row.disabled ? [] : row.rules ? [...row.rules] : [rules.required]
    },
    calcPadding(index) {
      const row = this.config[index]
      return row.cols && row.cols !== 12 && (index + 1) !== this.config.length && (this.config[index]?.isPadding ?? true)
    },
    async validate() {
      this.valid = await this.$refs.form.validate()
    },
    loadNewMaxMinValues(e) {
      this.loadingMinMaxValues = true;
      for (const item of this.configWorked) {
        item.disabled = true;
      }
      Form2OffersController.getBlockAndMaxMinInfoByKcpId(e, this.orgID)
        .then(res => {
          for (const item of this.configWorked) {
            item.disabled = res.blocks[item.fieldBlock] ?? false;
            const rangeValues = res.minMaxValues.find(el => el.foId === item.foId);
            if (rangeValues) {
              const {minUp, minLow, maxUp} = rangeValues;
              switch (item.dataField) {
                case 'qMinO':
                  item.rules = [
                    // ...row.rules,
                    v => Number(v) >= minLow || v == 0 || `значение должно быть >= ${minLow}, либо 0`,
                    v => Number(v) <= minUp || `значение должно быть <= ${minUp}`,
                  ]
                  break;
                case 'qMaxO':
                  item.rules = [
                    v => (this.editableData.qMinO == 0 && v == 0)
                      || (this.editableData.qMinO != 0 && Number(v) >= this.editableData.qMinO)
                      || `значение должно быть ${this.editableData.qMinO == 0 ? `= 0` : '>= ' + this.editableData.qMinO}`,
                    v => Number(v) <= maxUp || `значение должно быть <= ${maxUp}`,
                  ]
                  break;
                case 'qMinV':
                  item.rules = [
                    v => Number(v) >= minLow || v == 0 || `значение должно быть >= ${minLow}, либо 0`,
                    v => Number(v) <= minUp || `значение должно быть <= ${minUp}`,
                  ]
                  break;
                case 'qMaxV':
                  item.rules = [
                    v => (this.editableData.qMinV == 0 && v == 0)
                      || (this.editableData.qMinV != 0 && Number(v) >= this.editableData.qMinV)
                      || `значение должно быть ${this.editableData.qMinV == 0 ? `= 0` : '>= ' + this.editableData.qMinV}`,
                    v => Number(v) <= maxUp || `значение должно быть <= ${maxUp}`,
                  ]
                  break;
                case 'qMinZ':
                  item.rules = [
                    v => Number(v) >= minLow || v == 0 || `значение должно быть >= ${minLow}, либо 0`,
                    v => Number(v) <= minUp || `значение должно быть <= ${minUp}`,
                  ]
                  break;
                case 'qMaxZ':
                  item.rules = [
                    v => (this.editableData.qMinZ == 0 && v == 0)
                      || (this.editableData.qMinZ != 0 && Number(v) >= this.editableData.qMinZ)
                      || `значение должно быть ${this.editableData.qMinZ == 0 ? `= 0` : '>= ' + this.editableData.qMinZ}`,
                    v => Number(v) <= maxUp || `значение должно быть <= ${maxUp}`,
                  ]
                  break;
                default:
                  item.rules = []
                  break;
              }
            }
          }
        })
        .catch(() => {
          this.configWorked.find(el => el.dataField === 'kcpGroupId').disabled = false
          this.addNotification({
            notificationStatus: 'error',
            notificationMessage: 'По этой УГСН(НПС) отсутствуют объёмы контрольных цифр приема. Заполнение заявки невозможно.',
            timeout: 5000
          })
        })
        .finally(() => this.loadingMinMaxValues = false)
    },
    closeDialog() {
      this.$emit('closing-dialog');
      this.$options.dialogController.resolve(false);
      this.$refs.form.resetValidation();
      this.show = false;
    },
    saveData() {
      this.validate().then(() => {
        if (!this.valid) {
          return
        }
        this.$emit('change', {...this.additionalData, ...this.editableData});
        this.closeDialog()
      })
    },
    openDialog() {
      let resolve;
      let reject;
      const dialogPromise = new Promise((ok, fail) => {
        resolve = ok;
        reject = fail;
      })
      this.$options.dialogController = {resolve, reject};
      this.show = true;
      return dialogPromise;
    },
  },
}
</script>

<style scoped>

</style>